import { Badge as MantineBadge, BadgeProps as MantineBadgeProps } from "@mantine/core";
import styles from "./styles.module.css";
import { ReactNode } from "react";

export const badgeColor = {
  primary: "primary",
  completed: "completed",
  warning: "warning",
  error: "error",
  success: "success",
  gray: "gray",
  accent: "accent",
  selection: "selection",
  negativeOutline: "negativeOutline",
  positiveOutline: "positiveOutline",
  warningOutline: "warningOutline",
};

export interface BadgeProps extends MantineBadgeProps {
  children?: ReactNode;
  color?: string;
  noTextTransform?: boolean;
}

const Badge = ({ children, color = "var(--color-processing-primary)", noTextTransform, ...props }: BadgeProps) => {
  let bgColor = "";
  let border = "";
  let textColor = "";
  switch (color) {
    case "primary":
      bgColor = "var(--color-success-primary)";
      break;
    case "completed":
      bgColor = "var(--color-completed-primary)";
      break;
    case "warning":
      bgColor = "var(--color-warning-primary)";
      break;
    case "error":
      bgColor = "var(--color-negate-primary)";
      break;
    case "success":
      bgColor = "var(--color-completed-primary)";
      break;
    case "gray":
      bgColor = "var(--color-background-tertiary)";
      break;
    case "accent":
      bgColor = "var(--mantine-primary-color-light)";
      break;
    case "selection":
      bgColor = "var(--color-background-highlight-primary)";
      border = "1px solid var(--color-border-highlight)";
      textColor = "var(--color-text-secondary)";
      break;
    case "negativeOutline":
      bgColor = "var(--color-error-secondary)";
      border = "1px solid var(--color-error-primary)";
      textColor = "var(--color-error-primary)";
      break;
    case "positiveOutline":
      bgColor = "var(--color-success-secondary)";
      border = "1px solid var(--color-success-primary)";
      textColor = "var(--color-success-primary)";
      break;
    case "warningOutline":
      bgColor = "var(--color-warning-secondary)";
      border = "1px solid var(--color-warning-primary)";
      textColor = "var(--color-warning-primary)";
      break;
    default:
      bgColor = `${color}`;
  }

  return (
    <MantineBadge
      {...props}
      className={styles.badgeRoot}
      style={{
        textTransform: noTextTransform ? "capitalize" : "uppercase",
        ...props.style,
      }}
      autoContrast
      vars={() => ({
        root: {
          "--badge-bg": bgColor,
          "--badge-fz": "12px",
          ...(border && { "--badge-bd": border }),
          ...(textColor && { "--badge-color": textColor }),
        },
      })}
    >
      {children}
    </MantineBadge>
  );
};

export default Badge;
